import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import {
    IQueryParams,
    createEntitySlice,
    EntityState,
    serializeAxiosError,
    IOption,
    BaseResponseEntities,
} from 'app/shared/reducers/reducer.utils';
import { apiOrg, apiOkr } from 'app/config/axios-interceptor';
import { IProject, defaultValue } from 'app/shared/model/project.model';

const initialState: EntityState<IProject> = {
    loading: false,
    errorMessage: null,
    entities: [],
    entity: defaultValue,
    updating: false,
    totalItems: 0,
    updateSuccess: false,
};

const apiUrl = 'api/OKR/project';

// Actions

export const getEntities = createAsyncThunk(
    'projects/fetch_entity_list',
    async ({ searchText, page, size, sort, filters }: IQueryParams) => {
        return apiOkr.get<BaseResponseEntities<IProject>>(apiUrl, {
            params: {
                searchText,
                pageNum: page,
                pageSize: size,
                filters: filters && JSON.stringify(filters),
                sort: sort && sort,
                // cacheBuster: new Date().getTime(),
            },
        });
    },
    { serializeError: serializeAxiosError },
);

export const createEntity = createAsyncThunk(
    'projects/create_entity',
    async (entity: IProject, thunkAPI) => {
        const result = await apiOkr.post<IProject>(apiUrl, cleanEntity(entity));
        return result;
    },
    { serializeError: serializeAxiosError },
);


// slice

export const ProjectsSlice = createEntitySlice({
    name: 'projects',
    initialState,
    extraReducers(builder) {
        builder
            .addMatcher(isFulfilled(getEntities), (state: any, action) => {
                const { data, headers } = action.payload;
                return {
                    ...state,
                    loading: false,
                    entities: data,
                    totalItems: data.totalRecord,
                };
            })
            .addMatcher(isFulfilled(createEntity), (state, action) => {
                state.updating = false;
                state.loading = false;
                state.updateSuccess = true;
                state.entity = action.payload.data;
            })
            .addMatcher(isPending(getEntities), state => {
                state.errorMessage = null;
                state.updateSuccess = false;
                state.loading = true;
            })
            .addMatcher(isPending(createEntity), state => {
                state.errorMessage = null;
                state.updateSuccess = false;
                state.updating = true;
            });
    },
});

export const { reset } = ProjectsSlice.actions;

// Reducer
export default ProjectsSlice.reducer;
